import { render, staticRenderFns } from "./DemoSchedule.vue?vue&type=template&id=4033c526&"
import script from "./DemoSchedule.vue?vue&type=script&lang=js&"
export * from "./DemoSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports